import React from 'react';
import jss from 'jss';

import theme from '../../utils/theme';

const styles = (style) => ({
    root: {
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: style.cursor || 'pointer',
        '@media print': {
            display: 'none',
        },
    },
});

export default function CirclePlusIconComponent({ color, size = 14, customStyles, ...props }) {
    const { classes } = jss.createStyleSheet(styles({ ...customStyles })).attach();

    return (
        <span className={classes.root} {...props}>
            <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7.5V17.5" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
                <path d="M17 12.5H7" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
                <path d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
            </svg>

        </span>
    );
}

CirclePlusIconComponent.defaultProps = {
    color: theme.colors.caramel400,
    size: 10,
    type: 'button',
};
